
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-action-response",
      function () {
        return require("private-next-pages/office-action-response.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-action-response"])
      });
    }
  